import Head from 'next/head';
import type { BreadcrumbItem } from './types';
type SchemaGeneratorProps = {
  items: BreadcrumbItem[];
};
export function SchemaGenerator({
  items
}: SchemaGeneratorProps) {
  return <Head data-sentry-element="Head" data-sentry-component="SchemaGenerator" data-sentry-source-file="SchemaGenerator.tsx">
      <script type='application/ld+json' dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items.map(({
          title,
          route
        }, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: title,
          item: `https://wallex.ir${route}`
        }))
      })
    }} />
    </Head>;
}